import React from "react";
import { useTranslation } from "react-i18next";

import "./stepsSecurity.scss";

//Imagens:
import ImgStepsSecurity from "../../../../assets/advancedSecurity/stepsSecurity.png";
import Section from '../../../../components/utils/SectionComponent'

function StepsSecurity() {

  const { t } = useTranslation()

  return (
    <div className="container-steps-security">
      <div className="img-steps-security">
        <img src={ImgStepsSecurity} alt="" />
      </div>
      <div className="texts-steps-security">
        <Section title={t("security.steps.sso.title")} text={t("security.steps.sso.section_text")} />

        <Section title={t("security.steps.two_factor.title")} text={t("security.steps.two_factor.section_text_1")}>
          <p>{t("security.steps.two_factor.section_text_2")}</p>
        </Section>

        <Section title={t("security.steps.tracking_session.title")} text={t("security.steps.tracking_session.section_text_1")}>
          <p>{t("security.steps.tracking_session.section_text_2")}</p>
        </Section>

        <Section title={t("security.steps.whitelist.title")} text={t("security.steps.whitelist.section_text")} />
        <Section title={t("security.steps.log_tracing.title")} text={t("security.steps.log_tracing.section_text")} />
        <Section title={t("security.steps.password_rules.title")} text={t("security.steps.password_rules.section_text")} />
      </div>
    </div>
  );
}

export default StepsSecurity;
